import { TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import { cn } from '@/utils/cn';
import { useTab } from './tab-context';
import TabItem from './tab-item';
import { TabBarItem, TabSize, TabType } from './types';
interface Props {
  size: TabSize;
  type?: TabType;
  items: TabBarItem[];
  defaultIndex?: number;
  headClassName?: string;
  bodyClassName?: string;
  tabGroupClassName?: string;
  tabClassName?: string;
  isProductsHeader?: boolean;
  hasLeftPadding?: boolean;
}
const TabBarContent = ({
  size = TabSize.Medium,
  type = TabType.Normal,
  items,
  defaultIndex = 0,
  headClassName,
  bodyClassName,
  tabGroupClassName,
  tabClassName,
  isProductsHeader,
  hasLeftPadding
}: Props) => {
  const showTabs = items.length > 1;
  const {
    selectedIndex,
    changeSelectedIndex
  } = useTab();
  return <TabGroup selectedIndex={selectedIndex} onChange={changeSelectedIndex} defaultIndex={defaultIndex} className={cn({
    'p-2 pb-0 pl-0': type === TabType.PinkBox
  }, tabGroupClassName)} data-sentry-element="TabGroup" data-sentry-component="TabBarContent" data-sentry-source-file="tab-bar-content.tsx">
            <div className={cn({
      'pl-0': hasLeftPadding,
      'px-3': type === TabType.PDPGallery
    })}>
                <TabList className={cn('flex w-full items-center justify-between', headClassName, isProductsHeader ? 'gap-1.5 lg:gap-3' : 'gap-4', !showTabs && 'hidden')} data-sentry-element="TabList" data-sentry-source-file="tab-bar-content.tsx">
                    {items?.map(({
          header,
          disabled = false
        }, index) => <TabItem key={index} size={size} disabled={disabled} className={tabClassName} isProductsHeader>
                            {header}
                        </TabItem>)}
                </TabList>
            </div>
            <TabPanels className={cn('h-full', bodyClassName)} data-sentry-element="TabPanels" data-sentry-source-file="tab-bar-content.tsx">
                {items.map(({
        body,
        className
      }, index) => <TabPanel className={cn('h-full', className)} key={index}>
                        {body}
                    </TabPanel>)}
            </TabPanels>
        </TabGroup>;
};
export default TabBarContent;